<div nxRow>
    <div nxCol="12">
        <h4 nxHeadline="subsection-small" class="nx-font-weight-light bordered" translate>ma-insurance.car.coverage
        </h4>
    </div>
</div>

<div nxRow>
    <div nxCol="12" class="risk-item" *ngFor="let risk of maInsurance.risks">{{ risk.name }}</div>
</div>

<div nxRow>
    <div nxCol="12">
        <div class="insured-vehicle-headline">
            <div nxRow>
                <div nxCol="12" class="insured-vehicle-headline__edit">
                    <h4 nxHeadline="subsection-small" class="nx-font-weight-light" translate>
                        ma-insurance.car.insured-vehicle</h4>
                    <cpc-button size="small" mode="tertiary" (click)="editable()" *ngIf="showEdit && !editMode">
                        <nx-icon name="edit" class="nx-margin-left-2xs"></nx-icon>
                        {{ "popup.insured-vehicle.editBtn" | translate }}
                    </cpc-button>
                </div>
            </div>
            <div nxRow>
                <div nxCol="12">
                    <p translate>
                        ma-insurance.car.check-data-text
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div nxRow class="policy-vehicle-detail">
    <div nxCol="12">

        <form [formGroup]="form" (submit)="submit($event)">
            <div nxRow>
                <div nxCol="12,12,12,4">
                    <cpc-card-entry cardContentSize>
                        <span title translate>ma-insurance.car.brand</span>
                        <b>{{ maInsurance.vehicle.brand | stringFormat }}</b>
                    </cpc-card-entry>
                    <!-- editable -->
                    <cpc-card-entry style="display: {{ editMode?'none':'block' }}; ">
                        <span title translate>ma-insurance.car.crn</span>
                        <b>{{ maInsurance.vehicle.crn | stringFormat }}</b>
                    </cpc-card-entry>
                    <nx-formfield label="{{ 'ma-insurance.car.crn'|translate }}"
                        style="display: {{ !editMode?'none':'block' }}; ">
                        <input nxInput formControlName="crn" type="text" />
                    </nx-formfield>
                    <!-- /editable -->
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.engine-volume</span>
                        <b>{{ maInsurance.vehicle.engineVolume | stringFormat }}</b>
                    </cpc-card-entry>
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.color</span>
                        <b>{{ maInsurance.vehicle.color | stringFormat }}</b>
                    </cpc-card-entry>
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.imported-vehicle</span>
                        <b *ngIf="maInsurance.vehicle.importedVehicle"
                            translate>ma-insurance.car.imported-vehicle-yes</b>
                        <b *ngIf="!maInsurance.vehicle.importedVehicle"
                            translate>ma-insurance.car.imported-vehicle-no</b>
                    </cpc-card-entry>
                </div>

                <div nxCol="12,12,12,4">
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.model</span>
                        <b>{{ maInsurance.vehicle.model | stringFormat }}</b>
                    </cpc-card-entry>
                    <cpc-card-entry class="vin">
                        <span title translate>ma-insurance.car.vin</span>
                        <b>{{ maInsurance.vehicle.vin | stringFormat }}</b>
                    </cpc-card-entry>
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.engine-power</span>
                        <b>{{ maInsurance.vehicle.enginePower | stringFormat }}</b>
                    </cpc-card-entry>
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.sort</span>
                        <b>{{ maInsurance.vehicle.sort | stringFormat }}</b>
                    </cpc-card-entry>
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.kilometers-count</span>
                        <b>{{ maInsurance.vehicle.kilometersCount | stringFormat }}</b>
                    </cpc-card-entry>
                </div>

                <div nxCol="12,12,12,4">
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.variant</span>
                        <b>{{ maInsurance.vehicle.variant | stringFormat }}</b>
                    </cpc-card-entry>
                    <!-- editable -->
                    <cpc-card-entry style="display: {{ editMode?'none':'block' }}; ">
                        <span title translate>ma-insurance.car.vic</span>
                        <b>{{ maInsurance.vehicle.vic | stringFormat }}</b>
                    </cpc-card-entry>
                    <nx-formfield label="{{ 'ma-insurance.car.vic'|translate }}"
                        style="display: {{ !editMode?'none':'block' }}; ">
                        <input nxInput formControlName="vic" type="text" />
                    </nx-formfield>
                    <!-- /editable -->
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.fuel</span>
                        <b>{{ maInsurance.vehicle.fuel | stringFormat }}</b>
                    </cpc-card-entry>
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.chassis-type</span>
                        <b>{{ maInsurance.vehicle.chassisType | stringFormat }}</b>
                    </cpc-card-entry>
                    <cpc-card-entry>
                        <span title translate>ma-insurance.car.made-year</span>
                        <b>{{ maInsurance.vehicle.madeYear | stringFormat }}</b>
                    </cpc-card-entry>
                </div>
                <div nxCol="12" *ngIf="editMode" style="text-align:right;">
                    <button nxButton="secondary small" style="margin-right: 1em;" (click)="editable()">
                        <span translate>ma-insurance.form.cancelBtnText</span>
                    </button>
                    <button nxButton="primary small" type="submit">
                        <span translate>ma-insurance.form.submitBtnText</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>